export default __webpack_public_path__ + "static/media/home_find_ideal_bg.f3ab27ac.png";